import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import logo from '@/assets/logo.png';

interface HeroSectionProps {
  onGoogleLogin: () => void;
  isUnavailable?: boolean;
}

export function HeroSection({ onGoogleLogin, isUnavailable }: HeroSectionProps) {
  return (
    <section className="py-20 px-4">
      <div className="max-w-4xl mx-auto text-center">
        <img
          src={logo}
          alt="Blended Chat"
          className="h-24 md:h-32 mx-auto mb-8"
        />
        <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
          Meet People Worldwide in HD Video
        </h1>
        <p className="text-xl md:text-2xl text-gray-300 mb-4">
          Connect instantly with real people. Real-time translation in 38+ languages.
        </p>
        <p className="text-gray-400 mb-8 max-w-2xl mx-auto">
          Meet new friends, have meaningful conversations, and expand your horizons — all from the comfort of your home.
        </p>

        <div className="flex flex-col items-center gap-4">
          <Button
            onClick={onGoogleLogin}
            disabled={isUnavailable}
            className="h-14 px-10 text-lg font-semibold bg-[#11B981] hover:bg-[#0EA874] text-white disabled:bg-gray-600 disabled:cursor-not-allowed"
          >
            Start Chatting Free
          </Button>
          {isUnavailable ? (
            <p className="text-amber-400 text-sm">
              Service temporarily unavailable. Please try again later.
            </p>
          ) : (
            <Badge variant="secondary" className="bg-gray-800 text-gray-300 px-4 py-1">
              No download required
            </Badge>
          )}
        </div>
      </div>
    </section>
  );
}
